import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Fournisseurs } from './Fournisseurs';
import { Routeur } from './Routeur';
import './styles.css';

const racine = document.getElementById('racine');
if (racine === null) {
  // Une racine absente est un défaut de gabarit, pas un cas d'exécution : lever ici
  // le rend visible au premier chargement plutôt qu'à la première page blanche.
  throw new Error('La racine du document est introuvable.');
}

createRoot(racine).render(
  <StrictMode>
    <Fournisseurs>
      <Routeur />
    </Fournisseurs>
  </StrictMode>,
);
